module.exports = __webpack_public_path__ + "img/sha_metalwarmint.0357ab1.png";